import { syncedStore, getYjsValue } from "@syncedstore/core";
import { WebrtcProvider } from "y-webrtc";

const store = syncedStore({
  nodes: [],
  edges: [],
  controlValues: {},
});

const doc = getYjsValue(store);
export const webrtcProvider = new WebrtcProvider("testing", doc);

export const disconnect = () => webrtcProvider.disconnect();
export const connect = () => webrtcProvider.connect();

export default store;
